import { rem } from 'polished';
import styled from 'styled-components';
import { TrimTitleSectionStyled } from '../TrimTitleSectionStyled';

export const TrimTitleSectionStyledOV = styled(TrimTitleSectionStyled)`
    .title {
        font-size: ${rem(30)};
        font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
    }
`;
